import { SvgIcon } from "@mui/material";
import Swoosh from "../../../src/Assets/swoosh.svg?react";

const SwooshIcon = (props) => {
  return <SvgIcon {...props} component={Swoosh} inheritViewBox />;
};

export default SwooshIcon;
